import {
  ProvisioningSource,
  mapSourceValueToLabel,
} from '@/activityLog/bulkProvisioning/constants/provisioningSource.ts';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useSourceTranslation = () => {
  const { t } = useTranslation();
  return useCallback((value: ProvisioningSource) => mapSourceValueToLabel(value, t), [t]);
};
